/**
 * Centralized auth-related configuration constants.
 * Keep small, well-documented defaults here so code elsewhere imports values
 * instead of using magic numbers.
 */
const env = typeof process !== 'undefined' ? process.env || {} : {};

export const EXTERNAL_REFRESH_TIMEOUT_MS = Number(env.REACT_APP_EXTERNAL_REFRESH_TIMEOUT_MS) || 30000; // 30s
export const CIRCUIT_BREAKER_TIMEOUT_MS = Number(env.REACT_APP_CIRCUIT_BREAKER_TIMEOUT_MS) || 60000; // 60s
export const CIRCUIT_BREAKER_THRESHOLD = Number(env.REACT_APP_CIRCUIT_BREAKER_THRESHOLD) || 5;
export const PROACTIVE_REFRESH_DEBOUNCE_MS = Number(env.REACT_APP_PROACTIVE_REFRESH_DEBOUNCE_MS) || 400; // 400ms
export const TOKEN_SKEW_MS = Number(env.REACT_APP_TOKEN_SKEW_MS) || 2 * 60 * 1000; // 2 minutes
export const HTTP_DEFAULT_TIMEOUT_MS = Number(env.REACT_APP_HTTP_TIMEOUT_MS) || 5 * 60 * 1000; // 5 minutes
export const MAX_AUTH_RETRIES = Number(env.REACT_APP_MAX_AUTH_RETRIES) || 3;

export default {
  EXTERNAL_REFRESH_TIMEOUT_MS,
  CIRCUIT_BREAKER_TIMEOUT_MS,
  CIRCUIT_BREAKER_THRESHOLD,
  PROACTIVE_REFRESH_DEBOUNCE_MS,
  TOKEN_SKEW_MS,
  HTTP_DEFAULT_TIMEOUT_MS,
  MAX_AUTH_RETRIES,
};
